module.exports = __webpack_public_path__ + "img/XL.53f7a5d7.png";